const MODAL_TAB_TYPES = {
  BASIC: "basic-details",
  ADVANCED: "advance-details",
};

export default MODAL_TAB_TYPES;
